import React from 'react'
import { Button, Typography } from '@mui/material'
import Confirmmodal from '../../User/components/Confirm_modal'

const ProceedToBuyPopup = ({ handleProceedCloseModal, isProceed }) => {
  return (
    <>
      <Confirmmodal
        isOpen={isProceed}
        onClose={handleProceedCloseModal}
      >
        <section className="proceed-order">
          <div className="proceed-order-text">
            <Typography variant="h4">Blazer</Typography>
            <Typography variant="h5">Order Details<span>1 item</span></Typography>
          </div>
          <div className='proceed-order-btn'>
            <Button className='proceed-btn'>Confirm</Button>
          </div>
        </section>
      </Confirmmodal>
    </>
  )
}

export default ProceedToBuyPopup

